import React, { Component } from 'react';
import { search, checked, resizeManual, inboundCall, outBoundCall, framesCamp, iconInfo } from '../../../Images/Images';
import { closeSvg } from '../../../Images/GenericSVG'
import { callHistorySVG } from '../../../Images/CallRecordSVG'
import { moreOptions } from '../../../Images/CallSpaceHeaderSVG'
import { connect } from 'react-redux';
import { Singleton } from '../../../js/Singleton';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { ResizableBox } from 'react-resizable';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { USER_STATE, DRAGGABLE_WINDOWS, INTEGRATION } from '../../../constants'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { manualCallWindow } from '../../../js/draggableComponents';
import { insertWindow , removeWindow} from '../../../redux/actions/A_draggable_windows_controller';
import PlayerReproductor from '../Others/PlayerReproductor'
import { setCurrentSize, setTableOptions, setParameters, setTotalSelected } from '../../../js/Singletons/RecordCallSingleton.js';
import TableComponent from '../Others/TableComponent'
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { alertQueryErrorBody } from '../../../js/alertQueryErrorBody';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import AlertWindow from '../Others/AlertWindow.jsx';
import { setAllowPlayRecordsOnCallHistory } from '../../../redux/actions/A_agent_permissions';

class CallRecord extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.state = {
      selectedItem: null,
      searchRecord: "",
      moreOptionsShowed: false,
      tableWidth: parseInt(this.props.objProps.sizeWindow.widthWindow, 10),
      tableHeight: parseInt(this.props.objProps.sizeWindow.heightWindow, 10),
      minTableWidth: parseInt(this.props.objProps.sizeWindow.minTableWidth, 10),
      tableData: [],
      orderBy: "",
      orderFormat: true,
      showInfo: false,
      showAlertWindowNoInput: false,
      parametersCell: (this.props.objProps.paramsCell ? this.props.objProps.paramsCell :
        {
          Hour: { name: "Hour", size: 140 },
          Telephone: { name: "Telephone", size: 140 },
          Duration: { name: "Duration", size: 70 },
          CallKey: { name: "CallKey", size: 100 },
          Description: { name: "Description", size: 116 }
        }),
      tableOptions: (this.props.objProps.tableOptions ? this.props.objProps.tableOptions :
        [{ key: "Hour", description: this.language.getText("GUICallHistoryhour"), showed: true, locked: true, canOrder: true, id: 0, sizeWidth: 140, normalWidth: 140, minSizeWidth: 140, resize: false },
        { key: "Telephone", description: this.language.getText("GUICallHistoryphone"), showed: true, locked: true, canOrder: false, id: 1, sizeWidth: 140, normalWidth: 140, minSizeWidth: 90, resize: true },
        { key: "Duration", description: this.language.getText("GUICallHistoryduration"), showed: true, locked: true, canOrder: false, id: 2, sizeWidth: 70, minSizeWidth: 70, normalWidth: 70, resize: false },
        { key: "CallKey", description: this.language.getText("GUICallHistorycallKey"), showed: true, locked: false, canOrder: true, id: 3, sizeWidth: 100, minSizeWidth: 80, normalWidth: 100, resize: true },
        { key: "Description", description: this.language.getText("GUICallHistorycampaign"), showed: true, locked: true, canOrder: true, id: 4, sizeWidth: 116, minSizeWidth: 90, normalWidth: 116, resize: true },
        { key: "Disposition", description: this.language.getText("GUICallHistorydisposition"), showed: false, locked: false, canOrder: false, id: 5, sizeWidth: 140, minSizeWidth: 100, normalWidth: 140, resize: true }]),
        selectedItem: null,
      disabledPlayControl: false
    }
    this.totalSelected = this.props.objProps.totalSelected;
    this.sharedData = new SingletonSharedData();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.isIE = false;
    this.setting255 = "";
    this.maxHours = "";
    this.topRows = "";
    this.setting255 = this.sharedData.getGeneralPermissions()[255];
    this.loading = true;

  }
  componentDidMount() {
    this.isIE = false || !!document.documentMode;
    this.updateInfo();
    this.audioPlayerComponent = this.refs["PlayerReproductor"];
    this.maxHours = this.setting255.toString().slice(0, this.setting255.toString().indexOf('|'));
    this.topRows = this.setting255.toString().slice(this.setting255.toString().indexOf('|') + 1);
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.selectedItem !== this.state.selectedItem){
      this.setState({disabledPlayControl: this.props.allowPlayRecordsOnCallHistory});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userState.currentState === USER_STATE.DIALOG) {
      this.audioPlayerComponent.pausePlayer();
    }
    if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.OPEN_WINDOW && nextProps.messagesIntegrations.dataMessageIntegration.window === "CallRecord") {
      this.updateInfo();
    }
  }

  updateInfo() {
    let _this = this;
    let objectResponse = this.apiCont.getObjectResponse();
    this.apiCont.callHistory(this.sharedData.getParameters().UserID, objectResponse, this.sharedData.requestTimeout);
    objectResponse.onCatch = function (messageError) {
      _this.onCloseActions();
      _this.props.showAlertModal(alertQueryErrorBody());
    };
    objectResponse.onError = function (messageError) {
      _this.loading = false;
      const type = messageError.Type;
      const code = messageError.InternalCode
      const error = _this.language.getText(`${type.toLowerCase()}-${code}`);
      let integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnCallHistory" };
      SingletonWebSocket.send(integrationMessage);
    };
    objectResponse.onSuccess = function (objResponse) {
      _this.loading = false;
      let array = objResponse.CallHistoryList.map((item) => {        
        item["imageBackItem"] = (item.CallType === "IN" ? inboundCall : outBoundCall);
        item["imageItem"] = framesCamp[item.GraphicID];
        return item
      });
      let newArraySize = _this.resizeElements(_this.state.tableWidth - 210);
      _this.setState({
        tableOptions: newArraySize,
        parametersCell: _this.resizeParameters(newArraySize),
        tableData: array
      });
      if(array && array.length > 0 && array[0].AllowPlayRecordsOnCallHistory != null){
        _this.props.setAllowPlayRecordsOnCallHistory(array[0].AllowPlayRecordsOnCallHistory);
      }
      let sendArray = array.map((item) => {
        item.CallId,
        item.CallKey,
        item.Description,
        item.Disposition,
        item.Duration,
        item.HidePhone,
        item.Hour,
        item.IDCampEsp,
        item.Telephone,
        item.selectionActive,
        item.CamManualMode,
        item.SelectRotativeAniManualCall
        return item
      });
      SingletonWebSocket.send(
        SingletonWebSocket.getJson(INTEGRATION.CALL_RECORD, '', sendArray)
      );
    };
  }
  selectOption(idSelected) {
    var arrayOptions = this.state.tableOptions;
    var arrayParameters = this.state.parametersCell;
    arrayOptions[idSelected].showed = !arrayOptions[idSelected].showed;
    this.totalSelected += arrayOptions[idSelected].showed ? 1 : -1;
    var minWidth = arrayOptions.reduce((a, b) => { return (b.showed ? a + b.minSizeWidth : a) }, 0);
    minWidth = minWidth < 450 ? 450 : minWidth;
    let totalWidth = arrayOptions.reduce((a, b) => { return (b.showed ? a + b.normalWidth : a) }, 0);
    if ((arrayOptions[idSelected].showed && totalWidth <= this.state.tableWidth)) { totalWidth = this.state.tableWidth; }
    arrayOptions = this.resizeElements(totalWidth - 210, arrayOptions);
    if (arrayOptions[idSelected].showed) {
      arrayParameters[arrayOptions[idSelected].key] = { name: arrayOptions[idSelected].key, size: arrayOptions[idSelected].sizeWidth };
    } else {
      delete arrayParameters[arrayOptions[idSelected].key];
    }
    this.setState({
      tableOptions: arrayOptions,
      tableWidth: totalWidth,
      minTableWidth: minWidth,
      parametersCell: this.resizeParameters(arrayOptions, arrayParameters)
    });
  }
  onResize = (event, { size }) => {
    let newArraySize = this.resizeElements(size.width - 210);
    this.setState({
      tableWidth: size.width,
      tableHeight: size.height,
      tableOptions: newArraySize,
      parametersCell: this.resizeParameters(newArraySize)
    });
  };
  resizeElements(currentWidth, currentTableOption = this.state.tableOptions) {
    var remindOptions = this.totalSelected - 2;
    return currentTableOption.map((item) => { item.sizeWidth = (item.resize ? Math.floor((currentWidth - 18) / remindOptions) : item.sizeWidth); return item; });
  }
  resizeParameters(arrayOptions, newArrayParemeters = this.state.parametersCell) {
    var arrayParameters = newArrayParemeters;
    for (let i in arrayOptions) {
      let item = arrayOptions[i];
      if (item.showed) {
        arrayParameters[item.key] = { name: item.key, size: item.sizeWidth };
      }
    }
    return arrayParameters;
  }
  selectCell(itemSelected) {
    this.setState({ selectedItem: itemSelected });
    this.audioPlayerComponent.saveMarks();
    this.audioPlayerComponent.initLoading();
    let objectResponse = this.apiCont.getObjectResponse();
    let userID = this.sharedData.getParameters().UserID;
    let objSend = { "userId": userID, "calId": itemSelected.CallId, "type": itemSelected.CallType };
    this.audioPlayerComponent.setCallObject(objSend);
    this.apiCont.callAudio(objSend, objectResponse);
    let _this = this;
    objectResponse.onError = function () {
      _this.audioPlayerComponent.cleanPath();
      _this.audioPlayerComponent.recordNotFoundError();
    };
    objectResponse.onSuccess = function (objResponse) {
      _this.audioPlayerComponent.loadPath(objResponse.path, objResponse.marks);
    }
  }
  openManualCall(selected) {
    if(selected.CamManualMode === 3)
    {
      this.setState({showAlertWindowNoInput:true})
      setTimeout(() => {this.setState({showAlertWindowNoInput:false})}, 3000);
    }
    else{
      this.inserManualCallWindow(selected);
    }

  }
  inserManualCallWindow(selected){
    this.sharedData.phoneNumber = '';
      let objProps = null;
      if(selected.CallType === 'IN'){
        this.sharedData.phoneNumber = selected.Telephone;
      } else {
        objProps = {
          campaingName: selected.Description,
          campaingID: selected.IDCampEsp,
          phoneNumber: selected.Telephone,
          ManualCallAlwaysShow: true,
          disableManualCall: true,
          rotativeAniManualCall: selected.SelectRotativeAniManualCall      
        }
      }
      this.props.insertWindow(manualCallWindow(objProps), false);
  }
  
  shoWMoreOptions(evt) {
    this.setState({ moreOptionsShowed: !this.state.moreOptionsShowed });
    evt.stopPropagation();
  }
  onCloseActions() {
    this.props.removeWindow(DRAGGABLE_WINDOWS.CALL_RECORD);
    setCurrentSize({ widthWindow: this.state.tableWidth, heightWindow: this.state.tableHeight, minTableWidth: this.state.minTableWidth })
    setTableOptions(this.state.tableOptions);
    setParameters(this.state.parametersCell);
    setTotalSelected(this.totalSelected);

  }
  orderTable(item, Format) {
    this.setState({
      orderBy: item.key,
      orderFormat: Format,
    });
  }

  showInfoDetail() {
    this.setState({ showInfo: !this.state.showInfo });

  }


  render() {
    return (
      <ResizableBox className="boxResize" onResize={this.onResize}
        width={this.state.tableWidth} height={this.state.tableHeight} minConstraints={[this.state.minTableWidth, 326]} maxConstraints={[900, 600]}>
        <div className="CallRecord" onClick={() => this.props.goTopZ(this.props.id)}>
          {CUSTOM_COMPONENTS["draggableHeader"](callHistorySVG,
            this.language.getText("GUICallHistorytitle"),
            () => this.onCloseActions())}
          <div className="recordCallContainer">
            <div className={"topBar " + (this.loading ? "tbloading" : "")}>
              <p className={"infoRecordCall " + (this.loading ? "loading" : "")}><span className="infoNumberRecordCall"> {this.topRows} </span> {this.language.getText("GUICallHistorytotalCalls")} <span className="infoNumberRecordCall"> {this.maxHours} </span> {this.language.getText("GUICallHistoryhrs")}
                <button className="btnP" onClick={() => this.showInfoDetail()}>
                  <img src={iconInfo} alt="Info" />
                </button>{' '}
              </p>
              {this.state.showInfo &&
                <div className="CallHistoryinfo" >
                  <AlertWindow
                    title={this.language.getText("GUICallHistoryinfoTitle")}
                    body={this.language.getText('GUICallHistoryinfoBody')}
                    isGlobe={true}
                    isInfo={true} />
                </div>}
              {this.state.showAlertWindowNoInput &&
                <div className="alertContainerDisappear">
                  <AlertWindow
                    title={this.language.getText('GUIManualCallmanualCall')}
                    body={this.language.getText('GUIAlertMessagedialViaVataMsg')}
                    isGlobe={true} />
                </div>}
              {CUSTOM_COMPONENTS["inputDelete"](this.state.searchRecord, (e) => { this.setState({ searchRecord: e }) },
                "searchContainer " + (this.loading ? "loading" : ""), "txtSearch", "cleanButton", closeSvg, false, search, "iconSearch", this.language.getText("CallControlCRMxcontrolssearchForMatchesButton"))}
            </div>
            <div className="containerRecordCall">
              {this.state.tableOptions.map((item) => item.showed &&
                <div className={"itemHeaderCallRecord " + (this.loading ? "loading" : "")} style={{ width: item.sizeWidth }} key={item.key}>
                  {item.description}
                  {item.canOrder && <div className="orderContainer">
                    <div className="orderContainerBox" onClick={() => this.orderTable(item, true)}><div className="orderUp"></div></div>
                    <div className="orderContainerBox" onClick={() => this.orderTable(item, false)}><div className="orderDown"></div></div>
                  </div>}
                </div>)}
              <div className={"tableRecordCall " + (this.loading ? "loading" : "")}>
                <TableComponent
                  customCell={"cellRecordCall"}
                  parameters={this.state.parametersCell}
                  dataSource={this.state.tableData}
                  selectable
                  selectedStyle={"backgroundGray"}
                  onSelectItem={this.isIE ? undefined : this.selectCell.bind(this)}
                  selectedItem={this.state.selectedItem}
                  onDoubleClick={(itemSelected) => this.openManualCall(itemSelected)}
                  searching={this.state.searchRecord}
                  orderBy={this.state.orderBy}
                  orderForm={this.state.orderFormat}
                  pagination />
              </div>
              <div className="btnMoreOptions" onClick={(e) => this.shoWMoreOptions(e)}>{moreOptions}</div>
              {this.state.moreOptionsShowed &&
                <div className="moreOptionsBackGround" onClick={() => this.setState({ moreOptionsShowed: false })}>
                  <div className="moreOptions" onClick={(evt) => evt.stopPropagation()}>
                    {this.state.tableOptions.map((item) =>
                      <div className="optionTableSelection" key={item.key}>
                        <img className={"optionTableSelected " + (item.showed ? "selected " + (item.locked ? "locked" : "") : "")} src={checked} alt="icon" onClick={() => this.selectOption(item.id)}></img>
                        <p className={"optionTableTitle " + (item.locked ? "locked" : "")}>{item.description}</p>
                      </div>)}
                  </div>
                </div>}
            </div>
            <PlayerReproductor ref={"PlayerReproductor"} disabled={!this.state.disabledPlayControl} />

          </div>
          <img className="resizeButton" src={resizeManual} alt="icon"></img>
        </div>
      </ResizableBox>
    );
  }
}
function mapStateToProps(state) {
  return {
    userState: state.userState,
    messagesIntegrations: state.messagesIntegrations,
    allowPlayRecordsOnCallHistory: state.agentPermissions.allowPlayRecordsOnCallHistory
  }
}
function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;
  return ({
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    insertWindow: (dragWindow, closeComponentIfOpen) => { dispatch(insertWindow(dragWindow, closeComponentIfOpen)); },
    showAlertModal: payload => { dispatch(showAlertModal(payload)); },
    setAllowPlayRecordsOnCallHistory: allowPlayRecordsOnCallHistory => dispatch(setAllowPlayRecordsOnCallHistory(allowPlayRecordsOnCallHistory))
  });
}
export default CallRecord = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallRecord);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/CallRecord.jsx